"use client";

import { useEffect, useState } from "react";

/**
 * Renders how many years Varano has been in business (current year − founding
 * year). Recomputed in the browser on mount so the figure rolls over by itself
 * each new year without a redeploy — important because the site is a static
 * export, so a build-time-only value would stay frozen until the next deploy.
 *
 * `initial` is the build-time count baked into the static HTML, so the server
 * markup and the first client render match (no hydration mismatch); the effect
 * then corrects it against the visitor's actual current year.
 */
export default function YearsInBusiness({
  founded,
  initial,
}: {
  founded: number;
  initial: number;
}) {
  const [years, setYears] = useState(initial);

  useEffect(() => {
    setYears(new Date().getFullYear() - founded);
  }, [founded]);

  return <>{years}</>;
}
